import React, { PropTypes } from 'react';
import ReactTooltip from 'react-tooltip';
import DownloadContent from './DownloadContent';
import MapContent from './MapContent';
import DetailsContent from './DetailsContent';
import LightBox from '../Common/LightBox';
import { getBackgroundColor, getGroupInitials } from '../../businessLogic/util';
import { prettyAlert } from '../Common/Dialog';

export default class DocumentItem extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			x: 0, y: 0, 
			isFilesOpen: false, 
			isMapOpen: false, 
			isDetailsOpen: false, 
			locations: {}, 
			files: [],
			details: {} 
		};
	}

	getStyle(width = 400, height = 400) {
		const top = window.innerHeight < this.state.y + height ? (this.state.y - height) : this.state.y;
		const left = window.innerWidth < this.state.x + width ? (this.state.x - width) : this.state.x;
		return {
			overlay: { backgroundColor: 'rgba(255, 255, 255, 0.75)' },
			content: { 
				left: `${left}px`,
				top: `${top}px`, 
				height: `${height}px`,
				width: `${width}px`,
				overflowY: "auto", 
				overflowX: "hidden"
			}
		};
	}

	handleMapClick(e) {
		const { clientX, clientY } = e;
		const callback = (l) => {
			if ( l.sectors.length === 0 && l.localities.length === 0 &&
				l.samplingPoints.length === 0 && l.points.length === 0 &&
				l.rects.length === 0 ) {
				prettyAlert("Nenhuma localização cadastrada!");
				return;
			}
			this.setState({isMapOpen: true, x: clientX, y: clientY, locations: l});
		};
		this.props.getDocumentLocations(this.props.id, callback);
	}

	handleFilesClick(e) {
		const { clientX, clientY } = e;
		const callback = (files) => {
			if ( files.length === 0 ) {
				prettyAlert("Nenhum arquivo cadastrado!");
				return;
			}
			this.setState({isFilesOpen: true, x: clientX, y: clientY, files: files});
		};
		this.props.getDocumentFiles(this.props.id, callback);
	}

	onChangeFiles() {
		return this.props.getDocumentFiles(this.props.id, (files) => this.setState({files}));	
	}

	handleDetailsClick(e) {
		const { clientX, clientY } = e;
		const callback = (details) => this.setState({isDetailsOpen: true, x: clientX, y: clientY, details});
		this.props.getDocumentDetails(this.props.id, callback);
	}

	render () {
		const { id, title, viewDocument, groupName, groupId, isSelecting, isFavorite, getGeom } = this.props;			
		return (			
			<div className="document-container">
				<div className={`document-card cs-card ${isFavorite ? 'card-favorite' : "card-border"}`}>					
					<div className="document-left">
						<div className="rounded-div" style={{backgroundColor: getBackgroundColor(groupId)}}>
							<span 
								className="group-name" 
								data-tip={`${isFavorite ? "★ " : ""}${groupName}`} 
								data-place="left">
								{getGroupInitials(groupId)}
							</span>
							<ReactTooltip />
						</div>
					</div>
					<div className="document-center">
						<div className="document-title" title={title}>
							{title}
						</div>
					</div>
					<div className="document-right">
						<div className="document-actions">
							<span>
								<i 
									className="fa fa-eye pointer hoverable" 
									data-tip="Detalhes" 
									onClick={this.handleDetailsClick.bind(this)}
								/>								
								&nbsp;&nbsp;
								<i 
									className="far fa-map pointer hoverable" 
									data-tip="Localização" 
									onClick={this.handleMapClick.bind(this)}
								/>
								&nbsp;&nbsp;									
								<i 
									className="far fa-copy pointer hoverable" 
									data-tip="Arquivos" 
									onClick={this.handleFilesClick.bind(this)}
								/>																															
								&nbsp;&nbsp;
								<i 
									className="fa fa-edit pointer hoverable" 
									data-tip="Editar Informações" 
									onClick={() => viewDocument(id)} 
								/>
								&nbsp;&nbsp;
								<i 
									className={`fa${isFavorite ? "s" : "r"} fa-star pointer hoverable`} 
									data-tip={`${isFavorite ? "Remover" : "Adicionar"} Favorito`} 
									onClick={() => this.props.toggleFavorite(id)} 
								/>
							</span>							
							<ReactTooltip />
						</div>
						<div className="document-loading">
							{isSelecting === this.props.id 
								? <i className="fas fa-circle-notch fa-spin fa-fw" /> : null}
						</div>						
					</div>
					<LightBox						
						isOpen={this.state.isDetailsOpen}						 
						onClose={() => this.setState({isDetailsOpen: false})}
						style={this.getStyle(500, 400)}>
						<DetailsContent details={this.state.details} />
					</LightBox>
					<LightBox						
						isOpen={this.state.isFilesOpen}						 
						onClose={() => this.setState({isFilesOpen: false})}
						style={this.getStyle(400, 400)}>
						<DownloadContent 
							files={this.state.files}
							downloadFile={this.props.downloadFile}
							deleteFile={this.props.deleteFile}
							downloadFilesAsZip={this.props.downloadFilesAsZip}
							docId={this.props.id}
							onChangeFiles={this.onChangeFiles.bind(this)} />
					</LightBox>	
					<LightBox						
						isOpen={this.state.isMapOpen}
						onClose={() => this.setState({isMapOpen: false})}
						style={this.getStyle(600, 400)}>
						<MapContent 
							locations={this.state.locations}
							getGeom={getGeom}
							width="600px"
							height="400px" />
					</LightBox>
				</div>
			</div>			
		);
	}
}

DocumentItem.propTypes = {
	isFavorite: PropTypes.bool.isRequired,
	viewDocument: PropTypes.func.isRequired,
	getGeom: PropTypes.func.isRequired,
	getDocumentLocations: PropTypes.func.isRequired,
	downloadFile: PropTypes.func.isRequired,
	downloadFilesAsZip: PropTypes.func.isRequired,
	deleteFile: PropTypes.func.isRequired,
	toggleFavorite: PropTypes.func.isRequired,	
	getDocumentFiles: PropTypes.func.isRequired,
	getDocumentDetails: PropTypes.func.isRequired,
	id: PropTypes.number.isRequired,
	index: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired,
	groupName: PropTypes.string.isRequired,
	groupId: PropTypes.number,
	isSelecting: PropTypes.number
};


// WEBPACK FOOTER //
// ./src/components/Documents/DocumentItem.js